export default "__VITE_ASSET__DThNvBEU__"